<template>
  <div id="btnChangePassword">
    <v-menu
      v-model="menu"
      offset-y
      close-on-click
      :close-on-content-click="false"
      attach="#btnChangePassword"
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on">
          Змінити пароль
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <v-row dense>
            <v-col class="mb-n4 pb-0">
              <PasswordField
                v-model="newPassword"
                label="Новий пароль"
                outlined
                :error-messages="$v.newPassword.$error ? errors.NEW_PASSWORD : []"
                :hide-details="false"
                @input="$v.newPassword.$touch()"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col class="mb-n4 pb-0">
              <PasswordField
                v-model="confirmPassword"
                label="Підтвердження паролю"
                outlined
                class="mt-3"
                :error-messages="$v.confirmPassword.$error ? errors.CONFIRM_PASSWORD : []"
                :hide-details="false"
                @input="$v.confirmPassword.$touch()"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn
            :loading="loading"
            :disabled="!confirmPasswordIsValid"
            color="primary"
            text
            @click="changePassword"
          >
            Змінити
          </v-btn>

          <v-btn
            text
            @click="close"
          >
            Відмінити
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import * as usersApi from "@/backend/usersApi.js";
import { ERRORS } from "@/helpers";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";

export default {
  props: ["userId"],
  data: () => ({
    loading: false,
    menu: false,
    newPassword: "",
    confirmPassword: "",
  }),

  validations() {
    return {
      newPassword: {
        requiredIf: requiredIf(() => {
          if (this.isNew) {
            return {
              required,
            };
          }
        }),
        minLength: minLength(8),
      },
      confirmPassword: {
        requiredIf: requiredIf(() => {
          if (this.isNew) {
            return {
              required,
            };
          }
        }),
        minLength: minLength(8),
      },
    };
  },

  computed: {
    confirmPasswordIsValid() {
      return this.newPassword.length && this.newPassword === this.confirmPassword;
    },
    errors() {
      return {
        NEW_PASSWORD: [ERRORS.PASSWORD],
        CONFIRM_PASSWORD: [ERRORS.PASSWORD],
      };
    },
  },
  methods: {
    async changePassword() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;

      try {
        await usersApi.changePassword(this.userId, {
          newPassword: this.newPassword,
          confirmPassword: this.confirmPassword,
        });
        this.newPassword = "";
        this.confirmPassword = "";
        this.$notifySuccess();
        this.close();
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.menu = false;
    },
  },
};
</script>
